import React from "react";
import { useTranslation } from 'react-i18next';
import { MantineProvider, createTheme } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/tiptap/styles.css";

/**
 * Mantine Select dropdowns default to z-index 300 (popover). MUI Modal uses ~1300,
 * so dropdowns portaled to document.body render behind the modal unless raised.
 */
const editorMantineTheme = createTheme({
  components: {
    Select: {
      defaultProps: {
        comboboxProps: { zIndex: 10000 },
      },
    },
  },
});

/**
 * Wraps children with MantineProvider so Mantine components (e.g. RichTextEditor)
 * work without wrapping the entire app. Use this only around the editor to avoid
 * Mantine's global styles affecting the rest of the site.
 */
function MantineEditorWrapper({ children }) {
  const { t } = useTranslation();
  return (
    <MantineProvider theme={editorMantineTheme}>{children}</MantineProvider>
  );
}

export default MantineEditorWrapper;
